import { getGeoOverrideHeaders } from 'src/common/helpers/slices';
import type { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

import type { GenerateCheckoutUrlMutationArg } from './use-chargebee-checkout.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    generateCheckoutUrl: builder.mutation<unknown, GenerateCheckoutUrlMutationArg>({
      query: ({ path, payload }) => ({
        method: 'POST',
        url: `/payments/${path}`,
        body: payload || {},
        headers: getGeoOverrideHeaders(),
      }),
      transformResponse: (response: ApiResponse<unknown>) => response.data,
    }),
  }),
});

export const { useGenerateCheckoutUrlMutation } = extendedApiSlice;
